import allProfilePics from "src/preloading/profilePicsToPreload.json";

export const getRandomProfilePic = () => {
        return allProfilePics[Math.floor(Math.random() * allProfilePics.length)];
}